// Ballingo theme tokens — mirrors design_handoff_ballingo/ui.jsx.
// Light theme is the default. Dark theme keeps brand accent hues constant
// (only neutrals shift) so the visual identity stays consistent.

export const BALL = {
  bg: '#FFF8EE',
  bgAlt: '#FFFFFF',
  ink: '#2B1B0E',
  inkSoft: '#7A6655',
  hairline: '#EFE3D0',
  primary: '#FF7A45',
  primaryDeep: '#D5532A',
  gold: '#FFC857',
  goldDeep: '#D69A1F',
  blue: '#2D5BFF',
  blueDeep: '#1E40C9',
  mint: '#3DD68C',
  mintDeep: '#2BA86A',
  red: '#E63946',
  redDeep: '#B82A36',
  locked: '#E5DACA',
  lockedInk: '#B7A892',
};

export const DARK = {
  bg: '#15161F',
  bgAlt: '#1E2030',
  ink: '#FFF8EE',
  inkSoft: '#A89F8E',
  hairline: '#2A2C3D',
  primary: '#FF7A45',
  primaryDeep: '#D5532A',
  gold: '#FFC857',
  goldDeep: '#D69A1F',
  blue: '#4D77FF',
  blueDeep: '#2A4FCF',
  mint: '#3DD68C',
  mintDeep: '#2BA86A',
  red: '#E63946',
  redDeep: '#B82A36',
  locked: '#2A2C3D',
  lockedInk: '#5C5E72',
};

export function useTheme(dark) {
  return dark ? DARK : BALL;
}
